import type { IService } from '../work-orders'

export enum RepairRequestSubmissionStatus {
  Approved = 'Approved',
  Rejected = 'Rejected',
  UnderReview = 'Under Review',
}

export interface IRepairRequestSubmission {
  id: number
  customer: {
    id: number | null
    first_name: string
    last_name: string
    company_name: string | null
    email: string
    phone: string | null
  }
  repair_request: {
    customer_id: number
    number: string
    status: string
    work_order_number: string | null
  } | null
  scope_of_work: IService[]
  type: string
  expected_units: number
  miner_models: string[] | null
  status: RepairRequestSubmissionStatus
  notes: string | null
  reject_reason: string | null
  created_at: string
  updated_at: string | null
  updated_by: string | null
}
